import { render, staticRenderFns } from "./cartItemsDetails.vue?vue&type=template&id=cb08e728&"
import script from "./cartItemsDetails.vue?vue&type=script&lang=js&"
export * from "./cartItemsDetails.vue?vue&type=script&lang=js&"
import style0 from "./cartItemsDetails.vue?vue&type=style&index=0&id=cb08e728&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports